import moment from 'moment-timezone';
import React, { useEffect, useState } from 'react';
import MiniDonutIcon from './MiniDonutIcon';

interface OpeningHoursProps {
  place: any;
  timezone: string;
}

const OpeningHours = ({ place, timezone }: OpeningHoursProps) => {
  const [isOpen, setOpen] = useState(true);
  const [isJustClosed, setJustClosed] = useState(false);
  const [openTime, setOpenTime] = useState<moment.Moment | null>(null);
  const [closeTime, setCloseTime] = useState<moment.Moment | null>(null);

  useEffect(() => {
    const dayOfWeekNow = new Date().getDay();
    const dayNow = moment.tz(timezone).format('YYYY-MM-DD');

    const openingHours = place.opening_hours?.periods?.find(
      ({ open }) => open?.day === dayOfWeekNow
    );

    setJustClosed(
      place.opening_hours?.periods &&
        place.opening_hours.periods.length > 0 &&
        !openingHours
    );

    const openTimeNow =
      place && openingHours
        ? moment.tz(
            `${dayNow} ${openingHours.open.time.substr(
              0,
              2
            )}:${openingHours.open.time.substr(2, 4)}:00`,
            timezone
          )
        : null;
    const closeTimeNow =
      place && openingHours
        ? moment.tz(
            `${dayNow} ${openingHours.close.time.substr(
              0,
              2
            )}:${openingHours.close.time.substr(2, 4)}:00`,
            timezone
          )
        : null;

    setOpenTime(openTimeNow);
    setCloseTime(closeTimeNow);
    setOpen(
      openTimeNow?.isSameOrBefore(moment()) &&
        closeTimeNow?.isSameOrAfter(moment())
    );
  }, []);

  if (!isJustClosed && (!openTime?.isValid() || !closeTime?.isValid())) {
    return <span className="text-xl font-bold">coming soon!</span>;
  }

  return (
    <>
      <div className="flex items-center justify-start">
        {isOpen ? (
          <>
            <MiniDonutIcon className="w-3 h-auto mr-2 text-positive" />
            Open now
          </>
        ) : (
          <>
            <MiniDonutIcon className="w-3 h-auto mr-2 text-red-accessibility" />
            Closed now
          </>
        )}
      </div>
      {openTime && closeTime && (
        <div className="pl-5.5">
          {openTime?.format(openTime.format('m') === '0' ? 'h a' : 'h.mm a')} -{' '}
          {closeTime?.format(closeTime.format('m') === '0' ? 'h a' : 'h.mm a')}
        </div>
      )}
    </>
  );
};

export default OpeningHours;
